export default __webpack_public_path__ + "static/media/hamid-pic.a87226c1.jpg";